import React, { useState } from "react";
import { Formik } from "formik";
import FormInput from "../../../../../components/Universal/FormInput.component";
import DropDownInput from "../../../../../components/Universal/DropDownInput.component";
import DatePicker from "../../../../../components/Universal/DatePicker.component";
import { ReactComponent as FiPlus } from "../../../../../assets/Icons/Universal/PlusIconWithGreenBack.svg";

const Body = () => {
  const eventTypes = ["Online", "Offline"];
  const paymentModes = ["Cash", "Bank Transfer", "UPI", "Cheque"];
  const verifiers = ["Manager A", "Manager B", "Auditor X"];

  const [items, setItems] = useState([
    { itemName: "", quantity: "", price: "" },
  ]);

  const addItem = () => {
    setItems([...items, { itemName: "", quantity: "", price: "" }]);
  };

  return (
    <Formik
      initialValues={{
        eventName: "",
        description: "",
        b2bPartner: "",
        contact: "",
        eventType: "",
        eventDate: "",
        arrangements: items,
        totalCost: 0,
        paidAmount: "",
        gst: "",
        verifier: "",
        paymentMode: "",
      }}
      onSubmit={(values) => {
        console.log("Submitted:", values);
      }}
    >
      {({ values, setFieldValue, handleSubmit, touched, errors }) => (
        <form onSubmit={handleSubmit} className="p-1">
          <div className="grid grid-cols-2 gap-4 mb-05">
            <FormInput
              name="eventName"
              label="Event name"
              type="text"
              placeholder="Enter event name"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("eventName", e.target.value)}
            />
            <FormInput
              name="description"
              label="Description"
              type="text"
              placeholder="Type something here"
              touched={touched}
              errors={errors}
              setFieldValue={(e) =>
                setFieldValue("description", e.target.value)
              }
            />
            <FormInput
              name="b2bPartner"
              label="B2B partner/provider (if any)"
              type="text"
              placeholder="Enter name of partner"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("b2bPartner", e.target.value)}
            />
            <FormInput
              name="contact"
              label="Contact (if any)"
              type="text"
              placeholder="Enter phone number"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("contact", e.target.value)}
            />
            <DropDownInput
              name="eventType"
              label="Online/offline"
              value={values.eventType}
              placeholder="Choose options"
              suggestionList={eventTypes}
              setFieldValue={(val) => setFieldValue("eventType", val)}
            />
            <DatePicker
              name="eventDate"
              label="Date of event"
              value={values.eventDate}
              placeholder="Choose a date of event"
              setFieldValue={(val) => setFieldValue("eventDate", val)}
            />
          </div>

          <h3 className="text-lg font-semibold mt-4 mb-2">Arrangement</h3>
          {items.map((item, index) => (
            <div key={index} className="grid grid-cols-3 gap-4 mb-2">
              <FormInput
                label={`Item`}
                type="text"
                name={`arrangements[${index}].itemName`}
                value={item.itemName}
                placeholder="Enter item name"
                touched={touched}
                errors={errors}
                setFieldValue={(e) => {
                  const updated = [...items];
                  updated[index].itemName = e.target.value;
                  setItems(updated);
                  setFieldValue("arrangements", updated);
                }}
              />
              <FormInput
                label="Quantity"
                type="number"
                name={`arrangements[${index}].quantity`}
                value={item.quantity}
                placeholder="Enter item quantity"
                touched={touched}
                errors={errors}
                setFieldValue={(e) => {
                  const updated = [...items];
                  updated[index].quantity = e.target.value;
                  setItems(updated);
                  setFieldValue("arrangements", updated);
                }}
              />
              <FormInput
                label="Price (INR)"
                type="number"
                name={`arrangements[${index}].price`}
                value={item.price}
                placeholder="Enter total price"
                touched={touched}
                errors={errors}
                setFieldValue={(e) => {
                  const updated = [...items];
                  updated[index].price = e.target.value;
                  setItems(updated);
                  setFieldValue("arrangements", updated);

                  // Calculate total cost
                  const total = updated.reduce(
                    (sum, i) =>
                      sum +
                      parseFloat(i.quantity || 0) * parseFloat(i.price || 0),
                    0
                  );
                  setFieldValue("totalCost", total);
                }}
              />
            </div>
          ))}

          <button
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "1.2rem",
              cursor: "pointer",
            }}
            type="button"
            className="addBtn"
            onClick={addItem}
          >
            <FiPlus style={{ width: "24px", height: "24px" }} /> Add
          </button>

          <div style={{ marginTop: "16px" }} className="grid grid-cols-2 gap-4">
            <FormInput
              name="totalCost"
              label="Total cost (INR)"
              type="number"
              touched={touched}
              errors={errors}
              value={values.totalCost}
              disabled
            />
            <FormInput
              name="paidAmount"
              label="Paid amount (INR)"
              type="number"
              placeholder="Enter paid amount"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("paidAmount", e.target.value)}
            />
            <FormInput
              name="gst"
              label="GST (if any)"
              type="number"
              placeholder="Enter GST in %"
              touched={touched}
              errors={errors}
              setFieldValue={(e) => setFieldValue("gst", e.target.value)}
            />
            <DropDownInput
              name="verifier"
              label="Verifier"
              value={values.verifier}
              placeholder="Choose payment verifier"
              suggestionList={verifiers}
              setFieldValue={(val) => setFieldValue("verifier", val)}
            />
            <DropDownInput
              name="paymentMode"
              label="Payment mode"
              value={values.paymentMode}
              placeholder="Choose payment mode"
              suggestionList={paymentModes}
              setFieldValue={(val) => setFieldValue("paymentMode", val)}
            />
          </div>

          <button type="submit" className="actionBtn w-full mt-6">
            {items.length > 1 ? "Update" : "Collect"}
          </button>
        </form>
      )}
    </Formik>
  );
};

export default Body;
